import { modelConstant } from 'actionTypes';
import { Model } from 'services/model/model.type';
import {
  FetchModelsFailureAction,
  FetchModelsRequestAction,
  FetchModelsSuccessAction,
} from 'types/actions/model';

export const fetchModelsRequest = (): FetchModelsRequestAction => ({
  type: modelConstant.FETCH_MODELS_REQUEST,
});

export const fetchModelsSuccess = (models: Model[]): FetchModelsSuccessAction => ({
  type: modelConstant.FETCH_MODELS_SUCCESS,
  payload: models,
});

export const fetchModelsFailure = (error: Error): FetchModelsFailureAction => ({
  type: modelConstant.FETCH_MODELS_FAILURE,
  payload: error,
});

export const modelAction = {
  fetchModelsRequest,
  fetchModelsSuccess,
  fetchModelsFailure,
};
